import { Injectable, inject } from "@angular/core";
import { IStepOption } from 'ngx-ui-tour-md-menu';
import { ContentfulService } from "./contentful.service";
import { ContentfulConfigService } from "./contentful-config.service";
import { Observable, ReplaySubject } from "rxjs";
import { ContentfulResource } from "../models/classes/contentful-resource.class";
import { ContentfulClickThroughJourneyResponse } from "../models/interfaces/contentful-response.interface";

@Injectable({
    providedIn: 'root'
})
export class NgTourStepsService {
    private contentfulService = inject(ContentfulService);
    private contentfulConfig = inject(ContentfulConfigService);

    investorDashboardSteps: IStepOption[] = [];
    seriesDashboardSteps: IStepOption[] = [];
    dealDashboardSteps: IStepOption[] = [];
    assetDashboardSteps: IStepOption[] = [];
    defaultOptions: IStepOption;
    private contentfulDataFetched$ = new ReplaySubject<boolean>(0);

    constructor() {
        (this.contentfulService.fetchCommonAssets('clickThroughJourney', this.contentfulConfig.clickThroughJourney) as Observable<ContentfulClickThroughJourneyResponse>).subscribe((data) => {
            const stepData = data.data.landingPage.sectionsCollection.items;
            this.investorDashboardSteps = stepData[0].resourcesCollection.items.map((ele: ContentfulResource) => ({ anchorId: ele.key, title: ele.internalName, content: ele.value }));
            this.seriesDashboardSteps = stepData[1].resourcesCollection.items.map((ele: ContentfulResource) => ({ anchorId: ele.key, title: ele.internalName, content: ele.value }));
            this.dealDashboardSteps = stepData[4].resourcesCollection.items.map((ele: ContentfulResource) => ({ anchorId: ele.key, title: ele.internalName, content: ele.value }));
            this.assetDashboardSteps = stepData[3].resourcesCollection.items.map((ele: ContentfulResource) => ({ anchorId: ele.key, title: ele.internalName, content: ele.value }));
            this.contentfulDataFetched$.next(true);
        })
        this.defaultOptions = {
            endBtnTitle: 'Done',
            prevBtnTitle: 'Previous',
            smoothScroll: true,
            enableBackdrop: true,
            duplicateAnchorHandling: 'registerFirst',
            popoverClass: 'tour-popup-wrapper',
            disablePageScrolling: true,
            centerAnchorOnScroll: true,
            showProgress: false,
            showArrow: false
        }
    }

    getContentfulDataFetchedValue(): Observable<boolean> {
        return this.contentfulDataFetched$.asObservable();
    }
}